import { createApp, onMounted, ref } from 'vue'

let scripts, styles, tables = []
const templates = document.querySelectorAll('template')

templates.forEach(template => {
	styles  = template.content.querySelectorAll('style')
	scripts = template.content.querySelectorAll('script')
	const tables  = template.content.querySelectorAll('table')

	let nodeList = [
		...styles,
		...scripts
	]

	nodeList.forEach(node => node.remove())
	tables.forEach(table => {
		let parent = table.closest('.table-responsive')

		if(!parent) {
			parent = document.createElement('div')

			parent.classList.add('table-responsive')
			table.insertAdjacentElement('afterend', parent)
			parent.appendChild(table)
		}
	})
})

const App = createApp({
	setup() {
		const tab = ref('EMPRESA')
		const setTab = newTab => tab.value = newTab

		onMounted(() => {
			styles.forEach(style   => document.head.appendChild(style))
			scripts.forEach(script => document.body.appendChild(script))

			styles = scripts = null
		})

		return {
			tab,
			setTab,
		}
	}
})

export const registraComponent = (selector, options) => {
	if (!selector) selector = options.name

	App.component(selector, options)
}

export const registraGlobalComponents = componentMapList => {
	for(const [name, options] of Object.entries(componentMapList)) {
		registraComponent(name, options)
	}
}

export default App
